// PRH Opendata Registered Notices API v3
// Schema: https://avoindata.prh.fi/opendata-registerednotices-api/v3/schema?lang=fi
// Swagger: https://avoindata.prh.fi/fi/krek/swagger-ui

function getFiDescription(descriptions) {
    if (descriptions == null) return null;
    var entry = descriptions.find(function (d) { return d.languageCode === '1'; });
    return entry ? entry.description : null;
}

class BisLookup {
    constructor(json) {
        if (json != null) {
            this.totalResults = json.totalResults;
            this.results = [];
            if (json.companies != null && json.companies.length > 0) {
                for (let company of json.companies) {
                    this.results.push(new BisLoookupResult(company));
                }
            }
        }
    }
}

class BisLoookupResult {
    constructor(json) {
        if (json != null) {
            this.businessId = json.businessId != null ? json.businessId.value : null;
            this.registrationDate = json.registrationDate;
            this.companyForm =
                json.companyForms != null && json.companyForms.length > 0
                    ? getFiDescription(json.companyForms[0].descriptions)
                    : null;
            this.name = json.names != null && json.names.length > 0 ? json.names[0].name : null;
        }
    }
}

class BisDetails {
    constructor(json) {
        if (json != null) {
            this.names = [];
            if (json.names != null && json.names.length > 0) {
                for (let name of json.names) {
                    this.names.push(new BisCompanyName(name));
                }
            }
            this.addresses = [];
            if (json.addresses != null && json.addresses.length > 0) {
                for (let address of json.addresses) {
                    this.addresses.push(new BisAddress(address));
                }
            }
            this.companyForms = [];
            if (json.companyForms != null && json.companyForms.length > 0) {
                for (let companyForm of json.companyForms) {
                    this.companyForms.push(new BisCompanyForm(companyForm));
                }
            }
            this.businessId = json.businessId != null ? json.businessId.value : null;
            this.registrationDate = json.registrationDate;
            this.companyForm =
                json.companyForms != null && json.companyForms.length > 0
                    ? getFiDescription(json.companyForms[0].descriptions)
                    : null;
            this.name = json.names != null && json.names.length > 0 ? json.names[0].name : null;
        }
    }
}

class BisCompanyName {
    constructor(json) {
        this.source = json.source;
        this.version = json.version;
        this.type = json.type;
        this.registrationDate = json.registrationDate;
        this.endDate = json.endDate;
        this.name = json.name;
    }
}

class BisAddress {
    constructor(json) {
        if (json != null) {
            this.type = json.type;
            this.street = json.street;
            this.postCode = json.postCode;
            this.city = json.postOffices != null && json.postOffices.length > 0 ? json.postOffices[0].city : null;
            this.buildingNumber = json.buildingNumber;
            this.source = json.source;
            this.registrationDate = json.registrationDate;
            this.country = json.country;
        }
    }
}

class BisCompanyForm {
    constructor(json) {
        this.source = json.source;
        this.version = json.version;
        this.registrationDate = json.registrationDate;
        this.endDate = json.endDate;
        this.descriptions = json.descriptions != null ? json.descriptions : [];
        this.name = getFiDescription(json.descriptions);
        this.type = json.type;
    }
}

export default BisDetails;
export { BisLookup, BisDetails, BisLoookupResult };
